import { helpers, required } from '@vuelidate/validators';
import ApplicationsResidence from './ApplicationsResidence';
import LOCALIZATION from '../Localization';
export default class ApplicationsBusinessOperator {
	constructor(init) {
		this.operatorSameAsApplicant = null;
		this.firstName = null;
		this.lastName = null;
		this.relationshipDescription = null;
		this.address = new ApplicationsResidence();

		if (init) {
			this.operatorSameAsApplicant = init.operatorSameAsApplicant;
			this.firstName = init.firstName;
			this.lastName = init.lastName;
			this.relationshipDescription = init.relationshipDescription;
			this.address = new ApplicationsResidence(init.address);
		}
	}

	validation(language = 'English') {
		const requiredWithMessage = key => helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm[key][language], required);

		return {
			operatorSameAsApplicant: {
				required: requiredWithMessage('operatorSameAsApplicantRequired'),
			},
			firstName: { required: requiredWithMessage('firstNameOperatorRequired') },
			lastName: { required: requiredWithMessage('lastNameOperatorRequired') },
			relationshipDescription: {
				required: requiredWithMessage('relationshipDescriptionOperatorRequired'),
			},
			address: this.address.validation(false, language),
		};
	}
}
